import { Card, CardBody, Col } from "reactstrap";
import { BasicTimelineTitle } from "../../../constants";
import { BasicTimeLineData, BasicTimelineSubTitle } from "../../../data/bonusUi/Timeline";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const BasicTimeline = () => {
  return (
    <Col xl="6" className="box-col-6 notification main-timeline">
      <Card>
        <CommonCardHeader title={BasicTimelineTitle} span={BasicTimelineSubTitle} />
        <CardBody className="dark-timeline">
          <ul>
            {BasicTimeLineData &&
              BasicTimeLineData.map((item, index) => (
                <li className="d-flex" key={index}>
                  <div className={`timeline-dot-${item.class}`} />
                  <div className="w-100 ms-3">
                    <p className="d-flex justify-content-between mb-2">
                      <span className="date-content light-background">{item.date}</span>
                      <span>{item.time}</span>
                    </p>
                    <h6>{item.title}<span className="dot-notification"/></h6>
                    <p className="f-light">{item.text}</p>
                  </div>
                </li>
              ))}
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicTimeline;
